"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firebasePathForUser = void 0;
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
function firebasePathForUser(userId, path) {
    (0, tiny_invariant_1.default)(path[0] !== "/", "Path must not start with a slash");
    return "users/".concat(userId, "/").concat(path);
}
exports.firebasePathForUser = firebasePathForUser;
